import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import HeadlineInput from "editor/components/HeadlineInput";
import Editor from "editor/components/Editor";
import DropdownMenu from "components/library/DropdownMenu";
import PrimaryImage from "editor/components/PrimaryImage";

import styles from "./NewsletterChunk.css";
import { NEWSLETTER_CHUNK_PLACEHOLDER } from "config/constants/editor";
import { IMAGE_ROUTES } from "config/constants";
import AsyncDropdown from "../../../components/library/AsyncDropdown";
import { RUBRICS } from "../../../config/constants/editor";

export default class NewsletterChunk extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      isEditingHeader: false,
    };

    this.setChunkActive = this._setChunkActive.bind(this);
    this.setChunkInactive = this._setChunkInactive.bind(this);
    this.setEditingHeader = this._setEditingHeader.bind(this);
    this.unsetEditingHeader = this._unsetEditingHeader.bind(this);
  }

  _setChunkActive(e) {
    if (
      [this.outerRef, this.innerRef].includes(e.target) &&
      this.props.canReorderChunks
    ) {
      this.setState({ isActive: true });
    }
  }

  _setChunkInactive() {
    this.setState({ isActive: false });
  }
  _setEditingHeader() {
    this.setState({ isEditingHeader: true });
  }
  _unsetEditingHeader() {
    this.setState({ isEditingHeader: false });
  }
  render() {
    const { chunk, index } = this.props;

    const className = classNames(styles.border, {
      [styles.active]: this.state.isActive,
    });

    /**
     * Why does this have 4,000 wrapping divs? Because we want the hit box of
     * the onClick event to extend outside the border and only just inside the
     * border.
     */
    return (
      <div
        className={styles.root}
        onClick={this.setChunkActive}
        ref={node => {
          this.outerRef = node;
        }}
      >
        <div
          className={className}
          ref={node => {
            this.innerRef = node;
          }}
          onBlur={this.unsetEditingHeader}
        >
          <div className={styles.content}>
            {this.props.isLocalNewsletter &&
              ((chunk.rubric && chunk.rubric !== RUBRICS.DEFAULT) ||
                this.props.isChunkActive ||
                this.state.isEditingHeader) && (
                <div className={styles.field}>
                  <AsyncDropdown
                    className="gtm-select-newsletter"
                    inputId={"subscription"}
                    value={chunk.rubric || RUBRICS.DEFAULT}
                    onChange={e => {
                      this.props.onChange(`chunks.${index}.rubric`)(e);
                      this.unsetEditingHeader();
                    }}
                    loadOptions={this.props.getRubricListAsyncForTypeahead}
                    labelKey="name"
                    valueKey="id"
                    placeholder={"Select rubric"}
                    disabled={this.props.isReadOnly}
                    onFocus={this.setEditingHeader}
                  />
                </div>
              )}
            <HeadlineInput
              value={chunk.headline}
              onChange={this.props.onChange(`chunks.${index}.headline`)}
              displayAs="subhead"
              isDisabled={this.props.isReadOnly}
              onClick={this.setEditingHeader}
              onBlur={this.unsetEditingHeader}
            />
            <PrimaryImage
              getBaseUrl={this.props.getBaseUrl}
              imageEditorPath={`chunk/${chunk.id}/${IMAGE_ROUTES.PRIMARY}`}
              primaryImage={chunk.primary_image}
              formPath={`chunks.${index}.primary_image`}
              handleKeyCommand={this.props.handleKeyCommand}
            />
            <Editor
              onChange={this.props.updateEditor(`chunks.${index}.blocks`)}
              editorState={chunk.blocks}
              handleKeyCommand={this.props.handleKeyCommand}
              handleReturn={this.props.handleReturn}
              handlePastedText={this.props.handlePastedText}
              onTab={this.props.onTab}
              placeholder={NEWSLETTER_CHUNK_PLACEHOLDER}
              dataCy={"chunkBody"}
              readOnly={this.props.isReadOnly}
              multiEditorBlockComposition={
                this.props.multiEditorBlockComposition
              }
            />
            <DropdownMenu
              className={styles.dropdown}
              isVisible={this.state.isActive}
              onClose={this.setChunkInactive}
            >
              {index !== 0 && (
                <div
                  role="button"
                  onClick={() =>
                    this.props.moveNewsletterChunkUp(this.props.index)
                  }
                >
                  Move Up
                </div>
              )}
              {index !== this.props.chunkCount - 1 && (
                <div
                  role="button"
                  onClick={() =>
                    this.props.moveNewsletterChunkDown(this.props.index)
                  }
                >
                  Move Down
                </div>
              )}
              <div
                role="button"
                className={styles.delete}
                onClick={() =>
                  this.props.deleteNewsletterChunk(this.props.index)
                }
              >
                Delete
              </div>
              <div
                role="button"
                onClick={() =>
                  this.props.updateNewsletterChunk(this.props.index, {
                    is_expert_voices: !this.props.chunk.is_expert_voices,
                  })
                }
              >
                {this.props.chunk.is_expert_voices ? "Unm" : "M"}ark as Expert
                Voices
              </div>
            </DropdownMenu>
          </div>
        </div>
      </div>
    );
  }
}

NewsletterChunk.defaultProps = {
  canReorderChunks: true,
};

NewsletterChunk.propTypes = {
  chunk: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    blocks: PropTypes.object.isRequired,
    is_expert_voices: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  updateEditor: PropTypes.func.isRequired,
  handleKeyCommand: PropTypes.func.isRequired,
  handleReturn: PropTypes.func.isRequired,
  handlePastedText: PropTypes.func.isRequired,
  onTab: PropTypes.func.isRequired,
  updateNewsletterChunk: PropTypes.func.isRequired,
  moveNewsletterChunkUp: PropTypes.func.isRequired,
  moveNewsletterChunkDown: PropTypes.func.isRequired,
  deleteNewsletterChunk: PropTypes.func.isRequired,
  canReorderChunks: PropTypes.bool,
  multiEditorBlockComposition: PropTypes.object,
  isChunkActive: PropTypes.bool,
  isLocalNewsletter: PropTypes.bool,
};
